import type { FaireProductEntity } from "../../entity_types/product";

export const p_mc6qngy4vq: FaireProductEntity = {
  token: "p_mc6qngy4vq",
  type: "product",
  name: "The Easy Tea Strainer - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/eb68e953cc71edc0af3932ba5421ee90293bbb522bd930611405506d2515dd47.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8651808c6c5a634821d61729f10971ccc4182c868c3cedcfaf5de6dd956c7de3.jpeg"
  ],
  priceDollars: 7.5,
  description: "Steep & sip the perfect cup with this handy infuser. \n\nMeet your daily brewing companion - the Easy Tea Infuser! Made with durable stainless steel and a fine mesh strainer to keep all the little tea bits inside. The large basket gives the delicious tea leaves room to steep and brew for you the ultimate cuppa!\n\nTo Use: \n\nSpoon your favourite Lake & Oak Tea into the infuser, pour over boiling water, and steep for your desired amount of time. After steeping (we love to double steep the leaves!) compost the tea leaves, rinse the infuser with warm water, and air dry. ",
  tags: [],
  msrpDollars: 12.25,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:45.310Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
